import { useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { getCookie } from "../helperFunctions/cookies";
import { AuthSliceActions } from "../redux/features/auth/auth.slice";
import { layoutSliceActions } from "../redux/features/layout/layout.slice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { CLIENT_COOKIE_KEY, INACTIVITY_TIMEOUT } from "../utils/constants";

const handleTabClose = () => {
  localStorage.setItem("lastActiveTime", String(Date.now()));
};

const token = getCookie(CLIENT_COOKIE_KEY);

export const useIdle = () => {
  const { isLoggedIn } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();

  useIdleTimer({
    timeout: INACTIVITY_TIMEOUT,
    onIdle: () => {
      const isAuthenticated = !!token;

      if (isAuthenticated || isLoggedIn) {
        dispatch(layoutSliceActions.reset());
        dispatch(AuthSliceActions.logout());
      }
    },
    onActive: () => {},
    onAction: () => {},
    debounce: 500,
  });

  useEffect(() => {
    const lastActiveTimeStr = localStorage.getItem("lastActiveTime");
    const isAuthenticated = !!token;

    if (lastActiveTimeStr) {
      const lastActiveTime = Number.parseInt(lastActiveTimeStr, 10);

      if (
        Date.now() - lastActiveTime > INACTIVITY_TIMEOUT &&
        (isAuthenticated || isLoggedIn)
      ) {
        dispatch(layoutSliceActions.reset());
        dispatch(AuthSliceActions.logout());
      }
      localStorage.removeItem("lastActiveTime");
    }

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
    // eslint-disable-next-line
  }, []);

  return {};
};
